import { type PropsWithChildren } from 'react';

import { XYChartVisibleAxesConfigContext } from '../context/axes/XYChartVisibleAxesConfig.context.js';
import { useXYChartData } from '../hooks/useXYChartData.js';
import { getVisibleAxes } from '../utils/get-visible-axes.js';

export function XYChartVisibleAxesProvider({ children }: PropsWithChildren) {
  const { axes } = useXYChartData();

  const visibleAxes = getVisibleAxes(axes);

  return (
    <XYChartVisibleAxesConfigContext.Provider value={visibleAxes}>
      {children}
    </XYChartVisibleAxesConfigContext.Provider>
  );
}
